export const footerLinks = [
    {
        name: "Company",
        link: "#",
    },
    {
        name: "Product",
        link: "#",
    },
    {
        name: "Legal",
        link: "#",
    },
    {
        name: "Docs",
        link: "#",
    },
    
] 

